/* oxlint-disable no-top/no-top-level-side-effects -- Declarative Drizzle schema, like the actor _tables definitions. */
import { sql } from "@-/com.npmjs.drizzle-orm";
import { crudTable, date, index, integer, text } from "@-/dev.improve.haniverse.lib.database.table";

/**
 * A reward the learner received outside reviews: the daily login 红包 (Han, HanMiles, a review
 * bonus or a dragon, by cycle day) or a manual grant. The Han balance, HanMiles and the dragon
 * count sum the live rows.
 *
 * A daily-login row's id is deterministic (`daily-login:<claimedOn>`), so claiming the same local
 * day on two devices (or twice on one) collapses to a single row.
 */
export const rewardClaimTable = crudTable(
  "reward_claim",
  {
    claimedAt: date("claimed_at").notNull(),
    /** Local calendar day (`yyyy-MM-dd`) the reward belongs to. */
    claimedOn: text("claimed_on").notNull(),
    dragonAmount: integer("dragon_amount").notNull(),
    hanAmount: integer("han_amount").notNull(),
    hanMilesAmount: integer("han_miles_amount").notNull().default(0),
    /** `RewardClaimKind`: `"daily-login"` or `"grant"`. */
    kind: text("kind").notNull(),
    /**
     * Extra Han every review committed on `claimedOn` earns on top of its rating's, added to that
     * review's own `han_earned` when it is written.
     */
    reviewBonusHan: integer("review_bonus_han").notNull().default(0),
  },
  (table) => [
    index("reward_claim_claimed_on_idx")
      .on(table.claimedOn)
      .where(sql`${table.deletedAt} is null`),
  ],
);

export type RewardClaim = typeof rewardClaimTable.$inferSelect;
/* oxlint-enable no-top/no-top-level-side-effects */
